import { PROMPT_WORK_TYPES, PromptWorkType } from '@/types/prompts';

/**
 * A Prompt Group's type of work (spec FSI #1226, mobile fixes): the colour a
 * group tag takes, from the agent palette, by the work and not the agent.
 * Xano sends `work_type` on groups, on a template's group and on the
 * commands endpoint's groups, `ops` when a group has none.
 */
export const WORK_TYPE_LABELS: Record<PromptWorkType, string> = {
  ops: 'Ops',
  technical: 'Technical',
  sales: 'Sales',
  performance: 'Performance',
  safety: 'Safety',
  training: 'Training',
};

/** The picker's order: the three in use first. */
export const WORK_TYPE_OPTIONS = PROMPT_WORK_TYPES.map(id => ({
  id,
  label: WORK_TYPE_LABELS[id],
}));

const WORK_TYPES = new Set<string>(PROMPT_WORK_TYPES);

/** A known type of work, else `ops`. */
export const workTypeOf = (value: string | null | undefined): PromptWorkType =>
  value && WORK_TYPES.has(value) ? (value as PromptWorkType) : 'ops';
